import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import AuthLayout from 'layouts/AuthLayout';

import Button from 'primitives/Button';

import { FormInput, FormPanel } from 'components/FormPanel';

const SEND_OTP_MUTATION = gql(`
  mutation SendOTP($email: String!) {
    sendOTP(email: $email)
  }
`);

const Login: FC = () => {
  const location = useLocation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const navigate = useNavigate();
  const [sendOTP, { error, loading }] = useMutation(SEND_OTP_MUTATION);

  return (
    <AuthLayout title="Sign in to your account">
      <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
        <FormPanel
          loading={loading}
          error={error}
          onSubmit={formData => {
            sendOTP({
              variables: {
                email: formData.email,
              },
            }).then(({ data }) => {
              if (data?.sendOTP === true) {
                navigate(`/authenticate-otp?email=${formData.email}`, {
                  state: { from: location.state?.from },
                });
              }
            });
          }}
          buttonRef={buttonRef}
        >
          <FormInput
            fieldName="email"
            type="text"
            defaultValue=""
            label="Email"
            fullWidth
            validators={{ required: true }}
          />
        </FormPanel>
        <div className="mt-6">
          <Button
            loading={loading}
            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={() => {
              // @ts-ignore
              buttonRef.current?.submit();
            }}
          >
            Send One Time Password
          </Button>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
